// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowRotateRight16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-rotate-right': IconArrowRotateRight;
    }
}

/**
 * The icon component for the 'arrowRotateRight' icon
 */
export class IconArrowRotateRight extends IconSvg {
    public constructor() {
        super(arrowRotateRight16X16);
    }
}

registerIconSvg('icon-arrow-rotate-right', IconArrowRotateRight);
export const iconArrowRotateRightTag = 'nimble-icon-arrow-rotate-right';
